export class ParticipantData {
  constructor({
    playerId,
    playerNumber,
    country,
    groupName,
    playerName,
    gender,
    position,
    groupEvent,
    indivEvent,
    note,
    attendance,
  }) {
    this.playerId = playerId;
    this.playerNumber = playerNumber || "-";
    this.country = country || "";
    this.groupName = groupName || "";
    this.playerName = playerName || "";
    this.gender = gender || "";
    this.position = position || "";
    this.groupEvent = groupEvent || "";
    this.indivEvent = indivEvent || "";
    this.note = note || "";
    this.attendance = attendance || 0;
  }

  static fromJson(json) {
    return new ParticipantData({
      playerId: json.player_id ?? json.playerId ?? 0,
      playerNumber: json.player_number ?? json.playerNumber ?? "",
      country: json.country ?? "",
      groupName: json.group_name ?? json.groupName ?? "",
      playerName: json.player_name ?? json.playerName ?? "",
      gender: json.gender ?? "",
      position: json.position ?? json.position ?? "",
      groupEvent: json.group_event ?? json.groupEvent ?? "",
      indivEvent: json.indiv_event ?? json.indivEvent ?? "",
      note: json.note ?? "-",
      attendance: json.attendance ?? 0,
    });
  }

  _getEventStatus(eventsString) {
    try {
      const events = JSON.parse(eventsString);
      return {
        distance30: events.includes("30m") ? "O" : "-",
        distance70: events.includes("70m") ? "O" : "-",
        distance90: events.includes("90m") ? "O" : "-",
        distance145: events.includes("145m") ? "O" : "-",
      };
    } catch {
      return {
        distance30: "-",
        distance70: "-",
        distance90: "-",
        distance145: "-",
      };
    }
  }

  get genderLabel() {
    return this.gender === "W" ? "F" : this.gender;
  }

  get positionLabel() {
    let positions = [];
    try {
      positions = JSON.parse(this.position);
    } catch {
      positions = [];
    }
    const positionMap = {
      Executive: "Executive", // 임원
      Coach: "Coach", // 코치
      Player: "Player", // 선수
      Representative: "Representative", // 대표
    };
    const labels = positions.map((pos) => positionMap[pos] || pos);
    return labels.join(", ");
  }

  get groupEvents() {
    return this._getEventStatus(this.groupEvent);
  }

  get individualEvents() {
    return this._getEventStatus(this.indivEvent);
  }

  get attendanceLabel() {
    return this.attendance === 1 ? "O" : "X";
  }
}
